import React from 'react';
import { Link } from 'react-router-dom';

function Terms() {
  return (
    <>
      <section className="inner-intro bg-1 bg-overlay-black-70">
        <div className="container">
          <div className="row text-center intro-title">
            <div className="col-md-12 text-md-start d-inline-block">
              <div className="section-title">
                <h2 className="text-center" style={{color: 'white'}}>Terms and Conditions</h2>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="terms-and-conditions page-section-ptb">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="section-title">
                <span>Protecting your personal information</span>
                <h2>Terms And Conditions</h2>
                <div className="separator"></div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <h5 className="text-red">1. Service Overview</h5>
              <p>The Key Valet Parking Service ("we," "our," or "us") provides professional valet parking services in Doha, Qatar. By using our services, you agree to comply with and be bound by these Terms and Conditions. Please read them carefully before using our services.</p>

              <h5 className="text-red">2. Service Description</h5>
              <p>Our valet parking service includes the safe and secure parking of your vehicle at designated locations. We provide trained and professional valet attendants who will park and retrieve your vehicle upon request. Our services are available at various venues, events, and establishments throughout Doha, Qatar.</p>

              <h5 className="text-red">3. User Responsibilities</h5>
              <p>When using our valet parking service, you agree to:</p>
              <ul className="list-style-1">
                <li><i className="fa fa-angle-right"></i> Provide accurate vehicle information and contact details</li>
                <li><i className="fa fa-angle-right"></i> Remove all valuable items from your vehicle before handing it over to our valet attendants</li>
                <li><i className="fa fa-angle-right"></i> Ensure your vehicle is in good working condition and meets all legal requirements</li>
                <li><i className="fa fa-angle-right"></i> Inform us of any special requirements or vehicle conditions before service</li>
                <li><i className="fa fa-angle-right"></i> Present a valid valet ticket when retrieving your vehicle</li>
              </ul>

              <h5 className="text-red">4. Liability and Insurance</h5>
              <p>While we take utmost care in handling your vehicle, we maintain comprehensive insurance coverage for all vehicles under our care. However, we are not responsible for:</p>
              <ul className="list-style-1">
                <li><i className="fa fa-angle-right"></i> Personal belongings left inside the vehicle</li>
                <li><i className="fa fa-angle-right"></i> Pre-existing damage to the vehicle</li>
                <li><i className="fa fa-angle-right"></i> Mechanical failures or breakdowns</li>
                <li><i className="fa fa-angle-right"></i> Damage caused by force majeure events</li>
              </ul>

              <h5 className="text-red">5. Payment Terms</h5>
              <p>Payment for valet services is due at the time of vehicle retrieval unless otherwise agreed upon. We accept cash and major credit/debit cards. Prices may vary depending on the venue and duration of service.</p>

              <h5 className="text-red">6. Cancellation and Refund Policy</h5>
              <p>For pre-booked valet services, cancellations must be made at least 24 hours in advance for a full refund. Cancellations made within 24 hours of the scheduled service may incur a cancellation fee.</p>

              <h5 className="text-red">7. Privacy and Data Protection</h5>
              <p>We are committed to protecting your privacy. All personal information collected during the use of our services is handled in accordance with our Privacy Policy and applicable data protection laws in Qatar.</p>

              <h5 className="text-red">8. Modifications to Terms</h5>
              <p>We reserve the right to modify these Terms and Conditions at any time. Changes will be effective immediately upon posting on our website. Your continued use of our services after any such changes constitutes your acceptance of the new Terms and Conditions.</p>

              <h5 className="text-red">9. Contact Information</h5>
              <p>If you have any questions or concerns regarding these Terms and Conditions, please contact us at:</p>
              <p><strong>The Key Valet Parking Service</strong><br/>
              Office No. 102, Building 35, Al Mirqab Mall, Zone 38, Qatar<br/>
              Phone: +974 3377 7441<br/>
              Email: info@valetparking.qa</p>

              <Link to="/" className="button red"><span>Back to Home</span></Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Terms;
